const moduleRoutes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/modules/dashboard/Dashboard.vue'),
        meta: {
            resource: 'dashboard',
            action: 'view',
            auth: true,
            layout: 'default',
            title: 'Dashboard',
            breadcrumbs: []
        }
    },
    {
        path: '/',
        name: '',
        children: [
            {
                path: 'current-chat-list',
                name: 'currentchatList',
                component: () => import('@/modules/dashboard/ChatList.vue'),
                meta: {
                    resource: 'dashboard',
                    action: 'view_request_chat_count_card',
                    layout: 'default',
                    auth: true,
                    title: 'Current Chat List',
                    breadcrumbs: [{ title: 'Current Chat List', routeName: 'currentchatList' }]
                }
            },
            {
                path: 'complete-chat-list',
                name: 'completechatList',
                component: () => import('@/modules/dashboard/ChatList.vue'),
                meta: {
                    resource: 'dashboard',
                    action: 'view_completed_chat_count_card',
                    layout: 'default',
                    auth: true,
                    title: 'Completed Chat List',
                    breadcrumbs: [{ title: 'Completed Chat List', routeName: 'completechatList' }]
                }
            }
        ]
    }
]

export default moduleRoutes
